setTimeout(function() {
  // Taille du texte
  var messages = document.querySelectorAll('.announcement-bar__message');
  messages.forEach(function(msg) {
    msg.style.fontSize = '1.3rem';
  });

  // Masquer les flèches
  var prevBtn = document.querySelector('.announcement-bar-slider .slider-button--prev');
  var nextBtn = document.querySelector('.announcement-bar-slider .slider-button--next');
  if (prevBtn) prevBtn.style.display = 'none';
  if (nextBtn) nextBtn.style.display = 'none';

  // Autoplay
  var slider = document.querySelector('.slider--everywhere');
  if (!slider) return;
  if (slider.dataset.autoplay !== 'true') return;
  var slides = slider.querySelectorAll('.slideshow__slide');
  if (slides.length < 2) return;
  var speed = parseInt(slider.dataset.speed || 5) * 1000;
  setInterval(function() {
    if (nextBtn) nextBtn.click();
  }, speed);
}, 1500);

